import { connect } from 'react-redux';

import BoardTrendSlider from 'components/molecules/Board/BoardTrendSlider';
import {
	getHealthGoal,
	getIsMeasurmentDiagramLoading,
	getMeasurmentDiagrams,
	getMeasurmentDiagramUpdateKey,
} from 'store/dashboard';

const mapStateToProps = (state) => ({
	updateKey: getMeasurmentDiagramUpdateKey(state),
	isLoading: getIsMeasurmentDiagramLoading(state),
	diagrams: getMeasurmentDiagrams(state),
	healthGoal: getHealthGoal(state),
});

export default (connect(mapStateToProps) as any)(BoardTrendSlider);
